import { render } from "./NoticiasApp.vue?vue&type=template&id=5327120f&scoped=true"
import script from "./NoticiasApp.vue?vue&type=script&lang=js"
export * from "./NoticiasApp.vue?vue&type=script&lang=js"

import "./NoticiasApp.vue?vue&type=style&index=0&id=5327120f&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5327120f"]])

export default __exports__